















import { Component, Vue, Prop } from 'nuxt-property-decorator';
import BuildingIcon from '~/assets/svg/building.vue.svg';
import { srcCompanyImage } from '~/components/utils/responsive';

@Component<HeaderMenuNotificationsCardGridLogo>({
  components: {
    BuildingIcon,
  },
})
export default class HeaderMenuNotificationsCardGridLogo extends Vue {
  @Prop({ default: '' }) readonly src!: string;
  @Prop({ default: '' }) readonly title!: string;

  hasError = false;

  get rootClass() {
    return {
      'header-menu-notifications-card-logo': true,
      'header-menu-notifications-card-logo--empty': !this.isImageValid,
    };
  }

  get isImageValid() {
    return this.src && !this.hasError;
  }

  get cloudinarySrc() {
    return srcCompanyImage(this.src, 400);
  }

  onError() {
    this.hasError = true;
  }
}
